<template>
<div>
    <div v-for="element in contactElements" class="workflow-contact clickable" :key="element.key" @click="contactClicked(element)">
        <div class="truncate">{{element.contact|fullName}}</div>

        <div class="truncate" style="text-transform:uppercase;font-size:9px">
            <div style="font-size:11px;background-color:yellow;display:inline-block;line-height:0.9em;" v-if="element.contact.preferredName">Prefer {{element.contact.preferredName}}</div>
            <span>{{element.roles.join('/')}}</span>
        </div>

        <ContactImage :contact="element.contact" :size="46"/>
     
        <!-- <img class="round subtle-shadow" width="38" height="38" :src="getContactImage(element.contact)" /> -->

        <div v-if="!element.contact.notes" style="margin-top:0px">
            {{bestNumber(element.contact)}}
        </div>
        <v-tooltip v-else bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" style="text-decoration:underline;text-decoration-style:double;text-decoration-color:#aaa;margin-top:-8px;">
                    {{bestNumber(element.contact)}}
                </div>  
            </template>
            <span>{{element.contact.notes}}</span>
        </v-tooltip>

    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers.js'
import ContactHelpers from '../helpers/ContactHelpers.js'
import TeamHelpers from '../helpers/TeamHelpers.js'
import ContactImage from '../flow/ui/ContactImage'


export default {
    data() {
        return {
            blankAvatars: false,
        }
    },

    components: {
        ContactImage,
    },
    
    props: {
        contactElements: Array,
    },

    computed: {

    },

    methods: {
        getContactImage(contact) {
            return ContactHelpers.getContactImage(contact, this.blankAvatars)
        },
        contactClicked(element) {
            this.$emit('click', element)
            let path = DataHelpers.getTransactionRef().toString() + `/elements/${element.key}`
            console.log('TransactionContacts > contactClicked', path)
        },

        bestNumber(contact) {
            return ContactHelpers.bestNumber(contact)
        }
        
    },

    created() {
        TeamHelpers.fetchTeamSettings().then(settings => {
            this.blankAvatars = settings.blankAvatars
        })
    }
}
</script>

<style scoped>

.workflow-contact {
    text-align:center;
    border:solid 1px #ccc;
    border-radius:3px;
    display:inline-block;
    width:114px; height:114px;
    overflow: hidden;
    margin: 0px 0px 5px 9px;
    /* background-color:#e5e5e5; */
    /* background-color:#e5e5e5; */
    padding:5px;
    color:#666;
}

.workflow-contact:hover {
    background-color:#ddd;
}
   
</style>




// WEBPACK FOOTER //
// TransactionContacts.vue?4769c20c